module.exports = __webpack_public_path__ + "static/media/01.ba312fb5.JPG";